import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { AccountManager, ApiManager, Bus, getActiveForms, NotificationManager } from '@atlas/core';
import { onPasswordResetSubmit, useActiveForm } from '@atlas/react-forms';
import { staticRoutes } from '@atlas/routing';
import { Icon, Label } from '@atlas/ui';

import FormMobile from 'common/Form/FormMobile';
import { useHidePopupSignUpDelay } from 'hooks/useHidePopupSignUpDelay';
import { useSetNextShowPopupSignUpDelay } from 'hooks/useSetNextShowPopupSignUpDelay';

import { PHONE_RESET_TYPE } from './ForgotPassword';

const RESET_PASSWORD_TOKEN_NAME = 'rptk';

const ResetPassword = () => {
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const formType =
    searchParams.get('formType') === PHONE_RESET_TYPE ? 'PASSWORD_RESET_PHONE' : 'PASSWORD_RESET';
  // 'token' should be removed in future
  const resetToken = searchParams.get('token') || searchParams.get(RESET_PASSWORD_TOKEN_NAME);

  useEffect(() => {
    if (ApiManager.getAuthorizationToken()) {
      Bus.send({
        data: { withoutRedirect: true },
        event: Bus.events.auth.logout,
      });
    }
  }, []);

  const { activeStep, activeType, submit } = useActiveForm(
    formType,
    onPasswordResetSubmit(AccountManager.passwordResetWithForm.bind(AccountManager)),
    getActiveForms,
  );

  const submitHandler = React.useCallback(() => {
    history.replace(staticRoutes.signin);

    NotificationManager.notify({
      message: 'reset_password_title',
      status: 'success',
      type: 'notification',
    });
  }, [history]);

  const onBackButtonClick = React.useCallback(() => {
    return history.length === 1 ? history.push('/') : history.goBack();
  }, [history]);

  useHidePopupSignUpDelay();
  useSetNextShowPopupSignUpDelay();

  if (!activeType) {
    return null;
  }

  return (
    <div className="auth">
      <div className="header">
        <button className="top-button back-button" onClick={onBackButtonClick}>
          <Icon className="icon-back" name="back" />
        </button>
        <Label message="new_password" />
      </div>
      <div className="content">
        <FormMobile
          action={submit}
          additionalValues={{ resetToken }}
          buttonText="accept"
          className="reset-password-form"
          form={{ fields: activeType?.steps[0]?.fields, number: activeStep }}
          onSubmit={submitHandler}
        />
        <div className="signin-footer">
          <div>
            <Label
              className="title-300-text reset-padding"
              message="cant_use_password_after_reset"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
